module.exports = __webpack_public_path__ + "img/advantage_4.6ac2589a.png";